import { GetterTree } from 'vuex'
import { ContactState } from './types';
import { RootState } from '@/store/types'

export const getters: GetterTree<ContactState, RootState> = {
  email(state: ContactState): string {
    return state.contactInfos?.contactBaseInfo?.email ?? ''
  },
}
